import { render, staticRenderFns } from "./DraftReminder.vue?vue&type=template&id=b88d1d40&"
import script from "./DraftReminder.vue?vue&type=script&lang=js&"
export * from "./DraftReminder.vue?vue&type=script&lang=js&"
import style0 from "./DraftReminder.vue?vue&type=style&index=0&id=b88d1d40&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b88d1d40')) {
      api.createRecord('b88d1d40', component.options)
    } else {
      api.reload('b88d1d40', component.options)
    }
    module.hot.accept("./DraftReminder.vue?vue&type=template&id=b88d1d40&", function () {
      api.rerender('b88d1d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DraftReminder/components/DraftReminder.vue"
export default component.exports